// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-MenuItem_cls1__GqU-6","cls2":"VeloSplitFab-MenuItem_cls2__xW3Ij VeloSplitFab-MenuItem_cls1__GqU-6"};